import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Imported after index.css so the brand utility classes win over the Tailwind
// utilities they replace.
import './styles/genericTheme.css';
import "./fonts.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import './utils/appInsights';
import { applyOrgTheme, applyOrgFavicon } from './utils/themeUtil';

// Paint the active organization's palette onto <html> before the first render.
applyOrgTheme();
applyOrgFavicon();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
